import React, { useMemo } from "react";
import { DebouncedState } from "@/domains/react/useDebouncedCallback";

type DelayedHide = DebouncedState<(e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void>;

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export class MdsHoverContentGroup {
  hideFns: DelayedHide[] = [];

  hideAll = ({ exceptHideFn }: { exceptHideFn?: DelayedHide }) => {
    for (const hideFn of this.hideFns) {
      if (hideFn !== exceptHideFn) {
        hideFn();
        hideFn.flush();
      }
    }
  };
}

export const useMdsHoverContentGroup = () => {
  const group = useMemo(() => new MdsHoverContentGroup(), []);
  return group;
};
